import styled from "styled-components";

export const BlackBackground = (props: React.PropsWithChildren<unknown>) => (
  <Container>{props.children}</Container>
);

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: black;
`;
